import { FreeformIngredient, Ingredient } from "@juicy/models";
import { BatchDto } from "@juicy/models/dto";
import { useNavigation } from "@react-navigation/native";
import { Card, Divider, Icon, Text } from "@ui-kitten/components";
import React, { useMemo } from "react";
import { StyleSheet, View } from "react-native";
import { BatchNavigation } from "../navigation";
import { FreeformIngredientRow } from "../recipe/freeformIngredientRow";
import { IngredientRow } from "../recipe/IngredientRow";
import { getColorForRating, Rating } from "../recipe/rating";

interface BatchListItemProps {
    batch: BatchDto;
    ratingExpanded: boolean;
    handleSave?: (batch: BatchDto) => void;
}

interface CardHeaderProps {
    batch: BatchDto;
    ratingExpanded: boolean;
    handleSaveRating: () => void;
}

const CardHeader: React.FC<CardHeaderProps> = ({ batch, ratingExpanded, handleSaveRating, ...rest }) => {
    let bottle = 10;
    if (batch.size > 10) {
        bottle = 30;
    }

    return (
        <View {...rest} style={styles.cardHeader}>
            <View style={{ flexDirection: "row" }}>
                <View
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        // alignItems: "center",
                    }}
                >
                    {batch.nicStrength}mg
                </View>
                {batch.comments.length > 0 && (
                    <View
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Icon
                            name="message-circle-outline"
                            style={{
                                width: 16,
                                height: 16,
                                marginLeft: 10,
                            }}
                        />
                        <Text category="s1">{batch.comments.length}</Text>
                    </View>
                )}
            </View>
            <img
                src={require(`../../assets/bottle-${bottle}ml.png`)}
                style={{ display: "block", height: 60 }}
            />
            <Text numberOfLines={1} ellipsizeMode="tail" category="s1">
                {batch.size}ml
            </Text>
            <Rating
                size="large"
                rating={batch.rating}
                onChange={handleSaveRating}
                autoExpand={!ratingExpanded}
                disabled={!ratingExpanded}
            />
        </View>
    );
};

export const BatchListItem: React.FC<BatchListItemProps> = ({ batch, handleSave, ratingExpanded }) => {
    const navigation = useNavigation<BatchNavigation>();

    return useMemo(() => {
        const onSaveRating = async (rating?: number) => {
            const newBatch = { ...batch, rating };
            // setInternalBatch(newBatch);
            if (handleSave) {
                handleSave(newBatch);
            }
        };
        return (
            <Card
                onPress={() =>
                    navigation.navigate("BatchShowScreen", {
                        batchId: `${batch.userId}-${batch.recipeId}-${batch.recipeVersion}-${batch.batchNumber}`,
                    })
                }
                style={{
                    marginBottom: 5,
                    borderLeftWidth: 2,
                    borderLeftColor: getColorForRating(batch.rating),
                }}
                // onPress={() => navigation.navigate("RecipeStackScreen", {
                //     screen: "RecipeShowScreen",
                //     params: {
                //         recipeId: recipe.id
                //     },
                //     initial: false
                // })}
                header={() => (
                    <CardHeader handleSaveRating={onSaveRating} batch={batch} ratingExpanded={ratingExpanded} />
                )}
            >
                {batch.recipe.freeformIngredients &&
                    batch.recipe.freeformIngredients.length > 0 &&
                    batch.recipe.freeformIngredients.map((ffIngredient: FreeformIngredient) => (
                        <View key={ffIngredient.id}>
                            <FreeformIngredientRow freeformIngredient={ffIngredient} />
                            <Divider />
                        </View>
                    ))}
                {batch.recipe.ingredients &&
                    batch.recipe.ingredients.length > 0 &&
                    batch.recipe.ingredients.map((ingredient: Ingredient) => (
                        <View key={`${ingredient.recipeId}-${ingredient.recipeVersion}-${ingredient.flavorId}`}>
                            <IngredientRow ingredient={ingredient} />
                            <Divider />
                        </View>
                    ))}
            </Card>
        );
    }, [batch, navigation, ratingExpanded, handleSave]);
};

const styles = StyleSheet.create({
    cardHeader: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingTop: 10,
        paddingBottom: 10,
        paddingLeft: 16,
        paddingRight: 16,
    },
    topVersionBadge: {
        backgroundColor: "#efe0ff",
        border: "1px solid #5d19a6",
        borderRadius: 4,
        paddingTop: 1,
        paddingBottom: 1,
        paddingRight: 5,
        paddingLeft: 5,
    },
    subtitle: {
        display: "flex",
        flexDirection: "row",
        marginTop: 4,
    },
    gauge: {
        position: "absolute",
        width: 100,
        height: 160,
        alignItems: "center",
        justifyContent: "center",
    },
    gaugeText: {
        backgroundColor: "transparent",
        color: "#000",
        fontSize: 24,
    },
});
